import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Redirect, useHistory } from "react-router-dom";
import useService from "../../Hooks/useService";
import VirtualizedAppService from "../../../Services/VirtualizedApp.service";
import PersonTypeService from "../../../Services/PersonType.service";
import { getStartScreenBaseRoute } from "./VirtualizedAppRoutes";
import useParams from "../../Hooks/useParams";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import VirtualizedAppButton from "../../Presentational/VirtualizedApp/VirtualizedAppButton";
import CustomCard from "../../UI/CustomCard/CustomCard";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import useHelpIcon from "../../Hooks/useHelpIcon";
const FindApp = () => {
    let pathName = "";
    const history = useHistory();
    const params = useParams();
    const studentId = params.studentId;
    const tabId = params.tabId;
    const [appsState, loadApps] = useService(VirtualizedAppService.getAppsForFindPath);
    const [personTypes, loadPersonTypes] = useService(PersonTypeService.getPersonTypesForFindPath);
    const [selectedAppName, setSelectedAppName] = React.useState(null);
    const [selectedPersonTypeName, setSelectedPersonTypeName] = React.useState(null);
    const { icon: appIcon, text: appAlert } = useHelpIcon("The page you're going to exists in multiple apps and we're not sure which one to show you.  Select an app to be directed to that app.");
    const { icon: personTypeHelpIcon, text: personTypeHelpAlert } = useHelpIcon("This person has multiple person types and this app has more than one, so we're not sure which one to show you.  Select a person type to be directed to that person type.");
    const url = window.location.pathname;
    React.useEffect(() => {
        loadApps(url, studentId, tabId);
    }, [loadApps, studentId, tabId, url]);
    React.useEffect(() => {
        loadPersonTypes(url, selectedAppName, studentId, tabId);
    }, [loadApps, loadPersonTypes, selectedAppName, studentId, tabId, url]);
    const unknownApp = url.includes("/find/app/") || url.includes("/find/controller");
    const unknownPersonType = url.includes("/people/find");
    if (unknownApp && unknownPersonType) {
        // If app and person type is unknown
        if (appsState.data && appsState.data.length === 1) {
            pathName = url.replace("/find/app/", "/" + appsState.data[0].name + "/app/");
            pathName = pathName.replace("/find/controller/", "/" + appsState.data[0].name + "/controller/");
        }
        else if (appsState.data && appsState.data.length === 0) {
            return _jsx(Redirect, { to: getStartScreenBaseRoute() });
        }
        if (personTypes.data && personTypes.data.length === 1) {
            pathName = url.replace("/people/find", "/people/" + personTypes.data[0].internalName);
        }
        if (!(pathName === "")) {
            return _jsx(Redirect, { to: pathName + window.location.search });
        }
    }
    else if (unknownApp) {
        // If only app is unknown
        if (appsState.data && appsState.data.length === 1) {
            pathName = url.replace("/find/app/", "/" + appsState.data[0].name + "/app/");
            pathName = pathName.replace("/find/controller/", "/" + appsState.data[0].name + "/controller/");
            return _jsx(Redirect, { to: pathName + window.location.search });
        }
        if (appsState.data && appsState.data.length === 0) {
            return _jsx(Redirect, { to: getStartScreenBaseRoute() });
        }
    }
    else if (unknownPersonType) {
        // If only person type is unknown
        if (personTypes.data && personTypes.data.length === 1) {
            pathName = url.replace("/people/find", "/people/" + personTypes.data[0].internalName);
            return _jsx(Redirect, { to: pathName + window.location.search });
        }
    }
    function selectPersonType(personTypeName) {
        setSelectedPersonTypeName(personTypeName);
    }
    const displayPersonTypes = () => {
        var _a;
        if (((_a = personTypes.data) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            return (_jsx(AlertInfo, { message: "No person types found.  This person is not accessible in this app." }));
        }
        return (_jsx(CustomCard, { noShadow: true, children: _jsx("div", { className: "card-body", children: _jsx("div", { className: "row", children: personTypes.data &&
                        personTypes.data.map((personType) => (_jsx("div", { className: "col-md-2 col-6 my-1", children: _jsx(CustomCard, { noShadow: true, className: "mr-3", children: _jsx("button", { className: "btn btn-lg btn-link card-app" +
                                        (personType.internalName === selectedPersonTypeName
                                            ? " bg-primary"
                                            : ""), onClick: () => selectPersonType(personType.internalName), children: _jsx("div", { className: `h6 mb-0 ${personType.internalName === selectedPersonTypeName
                                            ? "text-white"
                                            : "text-dark"}`, children: personType.name }) }) }) }, personType.id))) }) }) }));
    };
    function redirectWithContext() {
        if ((!unknownApp || selectedAppName) &&
            (!unknownPersonType || selectedPersonTypeName)) {
            let path = url;
            if (selectedAppName) {
                path = path.replace("/find/app/", "/" + selectedAppName + "/app/");
                path = path.replace("/find/controller/", "/" + selectedAppName + "/controller/");
            }
            if (selectedPersonTypeName) {
                path = path.replace("/people/find", "/people/" + selectedPersonTypeName);
            }
            history.push(path + window.location.search);
        }
    }
    return (_jsx("div", { className: "fullHeightMinusPrimaryNav bg-light", children: _jsxs("div", { className: "container pb-3 pt-3", children: [unknownApp && (_jsxs("div", { className: "mb-3", children: [_jsxs("h3", { className: "my-3", children: ["Which app would you like to navigate to?", _jsx("span", { className: "ml-2", children: appIcon })] }), appAlert, _jsx(CustomCard, { noShadow: true, children: _jsx("div", { className: "card-body", children: _jsx(ServiceResult, { state: appsState, children: (apps) => (_jsx("div", { className: "row", children: apps === null || apps === void 0 ? void 0 : apps.map((app) => (_jsx("div", { className: "col-6 my-1 col-md-2", children: _jsx(VirtualizedAppButton, { selected: selectedAppName === app.name, virtualizedApp: app, onClick: () => setSelectedAppName(app.name) }) }, app.id))) })) }) }) })] })), personTypes.data &&
                    unknownPersonType &&
                    (selectedAppName || !unknownApp) && (_jsxs("div", { className: "mb-3", children: [_jsxs("h3", { className: "mt-4", children: ["Which person type would you like to navigate to?", _jsx("span", { className: "ml-2", children: personTypeHelpIcon })] }), personTypeHelpAlert, displayPersonTypes()] })), _jsx("div", { className: "mb-3 d-flex justify-content-between", children: _jsx("button", { type: "button", disabled: !((!unknownApp || selectedAppName) &&
                            (!unknownPersonType || selectedPersonTypeName)), className: "btn btn-primary btn-lg", onClick: () => redirectWithContext(), children: "Continue" }) })] }) }));
};
export default FindApp;
